import { render } from "./CarsToCheckTableColumns.vue?vue&type=template&id=37b9fd8c"
import script from "./CarsToCheckTableColumns.vue?vue&type=script&lang=js"
export * from "./CarsToCheckTableColumns.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./CarsToCheckTableColumns.vue?vue&type=style&index=0&id=37b9fd8c&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script